var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20,
    fill: "#ECF2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6992 17H18.6992",
    stroke: "#002E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5322 18H26.9302C25.1452 18 23.6992 19.343 23.6992 21C23.6992 22.657 25.1462 24 26.9292 24H29.5322C29.6162 24 29.6572 24 29.6922 23.998C30.2322 23.965 30.6622 23.566 30.6972 23.065C30.6992 23.033 30.6992 22.994 30.6992 22.917V19.083C30.6992 19.006 30.6992 18.967 30.6972 18.935C30.6612 18.434 30.2322 18.035 29.6922 18.002C29.6582 18 29.6162 18 29.5322 18Z",
    stroke: "#002E6E",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6642 18C29.5862 16.128 29.3362 14.98 28.5272 14.172C27.3562 13 25.4702 13 21.6992 13H18.6992C14.9282 13 13.0422 13 11.8712 14.172C10.7002 15.344 10.6992 17.229 10.6992 21C10.6992 24.771 10.6992 26.657 11.8712 27.828C13.0432 28.999 14.9282 29 18.6992 29H21.6992C25.4702 29 27.3562 29 28.5272 27.828C29.3362 27.02 29.5872 25.872 29.6642 24",
    stroke: "#002E6E",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6902 21H26.7002",
    stroke: "#002E6E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncome);
export default __webpack_public_path__ + "static/media/Income.65986d0b2d94c06eeb9fa677987c60e6.svg";
export { ForwardRef as ReactComponent };